export default function LibraryDetailsItem({ children }) {
    return (
        <div className="flex gap-2 text-sm">
            <dd>{children}</dd>
        </div>
    )
}